import axios from 'axios';
import { X_FUNLIDAY_HEADERS, getHeaders } from '../apis/main';
import { updateFirstLogin } from '../apis/login';
import { FUNLIDAY_STATUS } from '../constants/response';
import { LOGIN_TYPE, FIRST_LOGIN_ACTION } from '../constants/login';
import { UPDATE_FIRST_LOGIN } from '../actionTypes/login';
import {
  FETCH_TEXT_NOTE_FAIL,
  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_WITHOUT_EMAIL,
  USER_LOG_OUT,
  SET_MEMBER_NICKNAME
} from './action_types';
import { postSystemLog } from '../apis/system';
import {
  hasDiffAccountIdOnPlannerTool,
  getMasterAccountId
} from '../utilities/account';
// eslint-disable-next-line import/named
import { loginUrl, bindAccountUrl } from '../utilities/url_util';
import { setFunlidayCookie } from '../utilities/funlidayCookie';
import { writeWebToken } from '../utilities/initAdapter';

// login request
export const login = member => {
  const url = loginUrl();
  return async dispatch => {
    dispatch({ type: USER_LOGIN, payload: { member } });
    const parameters = {
      // 注意 FB Google 回的參數命名規則不太一樣
      ...(member.firstName && { firstName: member.firstName }),
      ...(member.first_name && { firstName: member.first_name }),
      ...(member.lastName && { lastName: member.lastName }),
      ...(member.last_name && { lastName: member.last_name }),
      ...(member.loginType && { loginType: member.loginType }),
      ...(member.uid && { uid: member.uid }),
      ...(member.id && { uid: member.id }),
      ...(member.token && { token: member.token }),
      // email
      ...(member.email && { email: member.email }),
      // email - alternative flow
      ...(member.customEmail && { customEmail: member.customEmail }),
      // yahoo login
      ...(member.yahooLoginCode && { yahooLoginCode: member.yahooLoginCode }),
      // apple login
      ...(member.appleSignInAuthorizationCode && {
        appleSignInAuthorizationCode: member.appleSignInAuthorizationCode
      }),
      // twitter login
      ...(member.loginType === LOGIN_TYPE.TWITTER && { ...member })
    };

    const { token: webToken } = JSON.parse(localStorage.getItem('webToken'));

    const headers = {
      ...X_FUNLIDAY_HEADERS,
      Authorization: `Bearer ${webToken}`
    };

    const loginRes = await axios.post(url, parameters, { headers });
    const loginResStatus = loginRes?.data?.status;
    try {
      console.log({ loginRes });
      if (
        loginRes.status === 200 &&
        loginResStatus === FUNLIDAY_STATUS.SUCCESS
      ) {
        // for recognize user login on funliday
        localStorage.setItem('funliday_hasLoggedin', true);
        const { results, token, validDate, expiredAt, isRegister, marketing } =
          loginRes.data.results;
        const bindAccountAPIPath = bindAccountUrl();
        const guestId = localStorage.getItem('guestId');
        const memberId = results._id;

        setFunlidayCookie('memberId', memberId);
        setFunlidayCookie('accessToken', token);
        const payload = {
          status: loginResStatus,
          results,
          accessToken: token,
          validDate,
          expiredAt,
          isMasterAccessLogin: true,
          isRegister,
          marketing
        };

        if (guestId) {
          const bindHeaders = {
            ...X_FUNLIDAY_HEADERS,
            Authorization: `Bearer ${memberId}_${token}`
          };
          const bindAccountResult = await axios.post(
            bindAccountAPIPath,
            { accountId: guestId },
            { headers: bindHeaders }
          );
          if (
            bindAccountResult.data.status === FUNLIDAY_STATUS.SUCCESS ||
            bindAccountResult.data.status === FUNLIDAY_STATUS.NO_RESULTS
          ) {
            if (bindAccountResult.data?.results?.token)
              payload.accessToken = bindAccountResult.data?.results?.token;
            dispatch({
              type: USER_LOGIN_SUCCESS,
              payload
            });
          } else {
            await handleLoginDebug(
              'login_action.js',
              {
                type: USER_LOGIN_FAIL,
                payload: {
                  status: bindAccountResult?.data?.status,
                  errorMessage: 'bind guest account error'
                }
              },
              'error'
            );
            dispatch({
              type: USER_LOGIN_FAIL,
              payload: {
                status: bindAccountResult?.data?.status,
                errorMessage: 'bind guest account error'
              }
            });
          }
        } else {
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload
          });

          setFunlidayCookie('memberId', memberId);
          setFunlidayCookie('accessToken', token);
        }
      } else {
        const { status, message } = loginRes.data;
        if (loginRes.status === 600) {
          await handleLoginDebug(
            USER_LOGIN_WITHOUT_EMAIL,
            status,
            message,
            parameters,
            webToken,
            'warn'
          );
        } else {
          await handleLoginDebug(
            USER_LOGIN_FAIL,
            status,
            message,
            parameters,
            webToken
          );
        }
        dispatch({
          type: USER_LOGIN_FAIL,
          payload: { status, errorMessage: message }
        });
      }
    } catch (error) {
      const { status, message } = loginRes.data;
      await handleLoginDebug(
        USER_LOGIN_FAIL,
        status,
        message,
        parameters,
        webToken
      );
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: { status, errorMessage: message }
      });
    }
  };
};

export const otpLogin = loginRes => async dispatch => {
  try {
    console.log({ loginRes });
    if (loginRes.status === 200) {
      const {
        status,
        results,
        token,
        validDate,
        expiredAt,
        isRegister,
        marketing
      } = loginRes.data.results;
      const bindAccountAPIPath = bindAccountUrl();
      const guestId = localStorage.getItem('guestId');
      const memberId = results._id;
      const payload = {
        status,
        results,
        accessToken: token,
        validDate,
        expiredAt,
        isMasterAccessLogin: true,
        isRegister,
        marketing
      };

      if (guestId) {
        const bindHeaders = {
          ...X_FUNLIDAY_HEADERS,
          Authorization: `Bearer ${memberId}_${token}`
        };
        const bindAccountResult = await axios.post(
          bindAccountAPIPath,
          { accountId: guestId },
          { headers: bindHeaders }
        );
        if (
          bindAccountResult.data.status === FUNLIDAY_STATUS.SUCCESS ||
          bindAccountResult.data.status === FUNLIDAY_STATUS.NO_RESULTS
        ) {
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload
          });
        } else {
          await handleLoginDebug(USER_LOGIN_FAIL, status, {
            status: bindAccountResult?.data?.status,
            errorMessage: 'bind guest account error'
          });
          dispatch({
            type: USER_LOGIN_FAIL,
            payload: {
              status: bindAccountResult?.data?.status,
              errorMessage: 'bind guest account error'
            }
          });
        }
      } else {
        dispatch({
          type: USER_LOGIN_SUCCESS,
          payload
        });
      }
    } else {
      const { status, message } = loginRes.data;
      if (loginRes.status === 600) {
        await handleLoginDebug(
          USER_LOGIN_WITHOUT_EMAIL,
          status,
          message,
          {},
          {},
          'warn'
        );
      }
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: { status, errorMessage: message }
      });
    }
  } catch (error) {
    const { status, message } = loginRes.data;
    await handleLoginDebug(status, message);
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: { status, errorMessage: message }
    });
  }
};

export const logout = () => ({
  type: USER_LOG_OUT
});

export const guestLogin = () => {
  const url = `${loginUrl()}Guest`;
  return async dispatch => {
    dispatch({ type: USER_LOGIN, payload: {} });
    const deviceIdFromOrigin = window?.funlidayLib?.deviceId;
    const parameters = { deviceId: deviceIdFromOrigin };

    const hasDiffAccount = hasDiffAccountIdOnPlannerTool();
    const masterAccountId = getMasterAccountId();
    if (hasDiffAccount && masterAccountId) {
      parameters.parentId = masterAccountId;
    }

    writeWebToken();
    const cachedWebToken = JSON.parse(localStorage.getItem('webToken'));
    const emblem = cachedWebToken?.token;

    if (!cachedWebToken) {
      await postSystemLog(
        'login_action.js',
        {
          type: USER_LOGIN_FAIL,
          payload: { status: '404', errorMessage: 'webToken not found' }
        },
        'error'
      );
      dispatch({
        type: USER_LOGIN_FAIL,
        payload: { status: '404', errorMessage: 'webToken not found' }
      });
      return;
    }

    const headers = {
      ...getHeaders(false),
      Authorization: `Bearer ${emblem}`
    };

    axios
      .post(url, parameters, { headers })
      .then(async response => {
        if (response.status === 200) {
          const { status, results, token, validDate, expiredAt, marketing } =
            response.data.results;
          const guestId = results._id;
          localStorage.setItem('guestId', guestId);
          dispatch({
            type: USER_LOGIN_SUCCESS,
            payload: {
              status,
              results,
              accessToken: token,
              validDate,
              expiredAt,
              isMasterAccessLogin: results.isMaster,
              marketing
            }
          });
        } else {
          const { status, message } = response.data;
          await handleLoginDebug(USER_LOGIN_FAIL, status, message, parameters);
          dispatch({
            type: USER_LOGIN_FAIL,
            payload: { status, errorMessage: message }
          });
        }
      })
      .catch(error => {
        dispatch({
          type: FETCH_TEXT_NOTE_FAIL,
          payload: { status: '404', errorMessage: error.message }
        });
      });
    // }, 1000);
  };
};

export const updateFirstLoginAction = params => async dispatch => {
  dispatch({ type: UPDATE_FIRST_LOGIN.LOADING });

  const { action, nickName, referralCode } = params;
  try {
    const changeResult = await updateFirstLogin(action, nickName, referralCode);

    if (changeResult?.data?.status === '200') {
      if (action === FIRST_LOGIN_ACTION.GET_STARTED) {
        dispatch({
          type: SET_MEMBER_NICKNAME,
          payload: { nickname: nickName }
        });
      }
      dispatch({
        type: UPDATE_FIRST_LOGIN.SUCCESS
      });
    } else {
      dispatch({ type: UPDATE_FIRST_LOGIN.FAIL, payload: changeResult?.data });
      return 'fail';
    }
  } catch (error) {
    dispatch({ type: UPDATE_FIRST_LOGIN.FAIL, payload: error });

    return 'fail';
  }
  return 'success';
};

const handleLoginDebug = async (
  type = USER_LOGIN_FAIL,
  status,
  message,
  parameters = {},
  webToken = {},
  level = 'error'
) => {
  // eslint-disable-next-line no-unused-vars
  const { firstName, lastName, ...rest } = parameters;
  console.log(
    'login_action.js',
    {
      type,
      payload: { status, errorMessage: message },
      // Purge names
      member: rest,
      webToken
    },
    level
  );
  await postSystemLog(
    'login_action.js',
    {
      type,
      payload: { status, errorMessage: message },
      // Purge names
      member: rest,
      webToken
    },
    level
  );
};
